import { render, staticRenderFns } from "./EventRecord.vue?vue&type=template&id=992df3aa&scoped=true&"
import script from "./EventRecord.vue?vue&type=script&lang=js&"
export * from "./EventRecord.vue?vue&type=script&lang=js&"
import style0 from "./EventRecord.vue?vue&type=style&index=0&id=992df3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992df3aa",
  null
  
)

component.options.__file = "EventRecord.vue"
export default component.exports